<template>
    <div class="modal fade max_popup" tabindex="-1" aria-labelledby="popup" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="popup">
                        <slot name="header">{{ header }}</slot>
                    </h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body d-flex flex-row">
                    <div class="w-50" style="border-right: 1px solid #000;">
                        <slot name="list">
                        </slot>
                    </div>
                    <div class="w-50">
                        <slot name="addNew">
                            <div class="ms-4">
                                <span>{{ $t("utils.addNewRecord") }}:</span>
                                <input type="text" class="form-control mt-1" v-model="input">
                                <button class="btn btn-primary text-white mt-3" @click="saveData(this.input)">{{ $t("utils.submit") }}</button>
                            </div>
                        </slot>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-dark" data-bs-dismiss="modal">{{ $t("utils.close") }}</button>
                    <button type="button" class="btn btn-primary text-white" data-bs-dismiss="modal"
                        @click="saveData(this.input)" v-if="editable">{{ buttonText }}</button>
                    <button type="button" class="btn btn-primary text-white" data-bs-dismiss="modal"
                        @click="saveData(this.input)" v-if="submitable">{{ buttonText }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['save-data'],
    props: {
        header: {
            type: String,
            required: false
        },
        data: {
            type: Array,
            required: false
        },
        editable: {
            type: Boolean,
            required: false,
            default: false
        },
        submitable: {
            type: Boolean,
            required: false,
            default: false
        },
        button: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            input: ""
        }
    },
    computed: {
        buttonText() {
            return this.button || this.$t('utils.submit'); // provides default value translation
        }
    },
    methods: {
        saveData(input) {
            this.$emit('save-data', input);
            this.input = "";
        },
        setInput(input) {
            this.input = input;
        }
    },
}
</script>


<style scoped lang="scss"></style>